export enum RULE_STATUS {
  DRAFT = 'draft',
  WAITING_FOR_APPROVAL = 'waiting_for_approval',
  LIVE = 'live',
  DECLINED = 'declined',
}
export enum RetentionMode {
  AFTER_PERIOD = 'AFTER_PERIOD',
  IMMEDIATE = 'IMMEDIATE',
}

export enum ConditionType {
  CASE_STATUS = 'case_status',
  SUBSTANTIATION = 'substantiation',
  CASE_CATEGORY = 'case_category',
  RELATIONSHIP_TO_COMPANY = 'RTC',
}

export enum RuleDrawerVariant {
  NEW = 'new',
  FALLBACK = 'fallback',
  EDIT = 'edit',
  EDITFALLBACK = 'editFallback',
}

export enum RuleCardVariant {
  FALLBACK = 'fallback',
  RETENTION = 'retention',
}

export interface RetentionRuleConditions {
  duration?: number;
  unit?: string;
  applyToAll?: boolean;
  condition?: string;
  conditionValue?: string | number;
}

export enum CaseStatus {
  SANITIZED = 'Sanitized',
  DELETED = 'Deleted',
}

export interface CaseMetadata {
  originalCaseId: string;
  appliedPolicy: string;
  caseStatus: string;
  caseClosed?: string;
  anonymizedOn?: string;
  deletedOn?: string;
  substantiation: string;
  retentionPeriod: string;
  country: string;
}

export interface DeletedSanitizedCase {
  id: string;
  title: string;
  status: CaseStatus;
  metadata: CaseMetadata;
}
